if (!customElements.get('wlsn-cart-remove-button')) {
  class WLSNCartRemoveButton extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        loading: 'loading',
      };

      this.isLoading = false;
      this.lineKey = this.dataset.lineKey;

      this.bindMethods = {
        handleClick: this._handleClick.bind(this),
        handleUpdateStart: this._handleUpdateStart.bind(this),
        handleUpdateSuccess: this._handleUpdateSuccess.bind(this),
        handleUpdateError: this._handleUpdateError.bind(this),
      };
    }

    get elements() {
      return {
        link: this.querySelector('a[href]'),
      };
    }

    connectedCallback() {
      this._attachEventListeners();
    }

    disconnectedCallback() {
      this._detachEventListeners();
    }

    _attachEventListeners() {
      const { link } = this.elements;

      if (link) {
        link.addEventListener('click', this.bindMethods.handleClick);
      }

      // Listen for cart update events from main cart
      document.addEventListener('wlsn:cart:update:start', this.bindMethods.handleUpdateStart);
      document.addEventListener('wlsn:cart:update:success', this.bindMethods.handleUpdateSuccess);
      document.addEventListener('wlsn:cart:update:error', this.bindMethods.handleUpdateError);
    }

    _detachEventListeners() {
      const { link } = this.elements;

      if (link) {
        link.removeEventListener('click', this.bindMethods.handleClick);
      }

      document.removeEventListener('wlsn:cart:update:start', this.bindMethods.handleUpdateStart);
      document.removeEventListener('wlsn:cart:update:success', this.bindMethods.handleUpdateSuccess);
      document.removeEventListener('wlsn:cart:update:error', this.bindMethods.handleUpdateError);
    }

    _handleClick(event) {
      event.preventDefault();
      if (this.isLoading) return;
      window.WLSNHelpers.triggerEvent(this, 'wlsn:cart:item:remove', { lineKey: this.lineKey });
    }

    _handleUpdateStart(event) {
      const { lineKey, action } = event.detail;
      if (lineKey === this.lineKey && action === 'remove') {
        this._setLoadingState(true);
      }
    }

    _handleUpdateSuccess(event) {
      // Cart will be re-rendered, element will be removed automatically
      // Just remove loading state in case of any delay
      this._setLoadingState(false);
    }

    _handleUpdateError(event) {
      const { lineKey, action } = event.detail;
      if (lineKey === this.lineKey && action === 'remove') {
        this._setLoadingState(false);
      }
    }

    _setLoadingState(loading) {
      this.isLoading = loading;
      this.classList.toggle(this.classes.loading, loading);
    }
  }

  customElements.define('wlsn-cart-remove-button', WLSNCartRemoveButton);
}
